import React, { FC, ChangeEvent } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';

type CategoriesPageActionsProps = {
    onNewCategoryClick: () => void;
    onFilterChange: (filters: { freetext: string }) => void;
};
const CategoriesPageActions: FC<CategoriesPageActionsProps> = ({
    onNewCategoryClick,
    onFilterChange,
}: CategoriesPageActionsProps) => {
    const { t: translate } = useTranslation(['lab-settings']);

    const handleFreetextChange = (freetext: string) => {
        onFilterChange({
            freetext: freetext,
        });
    };

    return (
        <Box mb={1} display="flex" alignItems="center" justifyContent="space-between">
            <TextField
                id="search-category"
                margin="dense"
                name="search"
                label={translate('lab-settings:SEARCH_CATEGORY')}
                onChange={(event: ChangeEvent<HTMLInputElement>) => handleFreetextChange(event.target.value)}
                sx={{ minWidth: '400px' }}
            />

            <Button
                sx={{ whiteSpace: 'nowrap' }}
                variant="contained"
                onClick={onNewCategoryClick}
                startIcon={<AddIcon />}
            >
                {translate('lab-settings:NEW_CATEGORY')}
            </Button>
        </Box>
    );
};

export default CategoriesPageActions;
